var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9584 5.91569L5.30186 3.50989L1.72153 0.267489C1.67376 0.224228 1.62239 0.186214 1.56829 0.153448C1.1764 -0.0839154 0.64142 -0.0459019 0.295367 0.267489C-0.0984557 0.62414 -0.0984557 1.20239 0.295367 1.55904L0.436298 1.68667L4.0416 4.95168L6.69814 7.35748L9.61607 10L6.69814 12.6425L4.0416 15.0483L0.436297 18.3133L0.295367 18.441C-0.0984557 18.7976 -0.0984557 19.3759 0.295367 19.7325C0.64142 20.0459 1.1764 20.0839 1.56829 19.8466C1.62239 19.8138 1.67376 19.7758 1.72153 19.7325L5.30186 16.4901L7.9584 14.0843L11.5637 10.8193L11.7046 10.6917C11.9144 10.5017 12.0125 10.2488 11.9987 10C12.0125 9.75123 11.9144 9.49833 11.7046 9.30833L11.5637 9.1807L7.9584 5.91569Z",
    fill: "#7E888C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c01c75b17c7f3b95d133c0a639b20e3c.svg";
export { ForwardRef as ReactComponent };